
import Vue from 'vue';
import { achievementLevels, achievementSizes } from '~/components/partials/war-room/constants';

export default Vue.extend({
  name: 'WarRoomAchievement',
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    level: {
      type: String,
      default: achievementLevels.GOLD,
      required: true,
      validator: (level: string) => Object.values(achievementLevels).includes(level),
    },
    size: {
      type: String,
      default: achievementSizes.SMALL,
      validator: (size: string) => Object.values(achievementSizes).includes(size),
    },
  },
  computed: {
    rootClasses(): string[] {
      return ['war-room-achievement', `war-room-achievement--${this.level}`, `war-room-achievement--${this.size}`];
    },
  },
});
